function containsCorrectTabIndex (tabIndex) {
  return (parseInt(tabIndex, 10) > -1 || isNaN(parseInt(tabIndex, 10)))
}

const getFocusables = function (root) {
  const elements = root.querySelectorAll(
    'a[href],' +
    'button:not([disabled]),' +
    'area[href],' +
    'input:not([type=hidden]):not([disabled]):not([readonly=readonly]):not([disabled]),' +
    'textarea:not([disabled]),' +
    'iframe,' +
    'object,' +
    'embed,' +
    '[tabindex],' +
    '[contenteditable],' +
    '[data-selectable],' +
    'div[tabindex]'
  )
  return Array.from(elements).filter(element => element.style.display !== 'none' && containsCorrectTabIndex(element.tabIndex))
}

export {
  getFocusables
}



// WEBPACK FOOTER //
// ./src/utils/focusable.js